export const whatYouReceiveItems = [
  '6 tomos digitales en PDF',
  'Ejercicios con indicaciones de ejecución',
  'Errores frecuentes y correcciones',
  'Opciones de progresión y regresión',
  'Materiales adicionales de apoyo'
];
